import React, { Component } from 'react';
import SideMenu from '../SideMenu/SideMenu';
import Header from '../Header/Header';
import { DataTable } from '../DataTable/DataTable';
import { connect } from 'react-redux';
import UserSearchComponent from './UserSearch';
import AddUserModalComponent from './AddUserModal';
import { actions } from '../../helpers/messages';
import { Roles } from '../../helpers/constants';
class UserListComponent extends Component {

    /**
     * @description function to handle user's role display
     * @param {*}
     * @memberof UserListComponent
     */
    /* istanbul ignore next  */
    getRoleNames = (userRoles) => {
        if (!userRoles || !userRoles.length) {
            return 'N/A';
        }
        var rolesText = '';
        if (userRoles.length > 1) {
            userRoles.sort();
        }
        userRoles.forEach((userRole, i) => {
            let role = Roles.find(x => x.cognitoGroupName === userRole);
            rolesText += role ? `${i > 0 ? ', ' : ''}${role.label}` : '';
        });

        return rolesText;
    }

    render() {
        const { loading, toggleLoader, fromDashboard, searchString, activeUsersOnly, searchSubmit, filterActiveUsers, refreshUserList, handleSearchSubmit, handleReset, userUpdated, userStatusUpdated, newUserName } = this.props;
        /* istanbul ignore next  */
        const columns = [
            {
                Header: 'Name',
                accessor: 'name',
                Cell: ({ row }) => (<span>{row.original.name ? row.original.name : 'N/A'}</span>),
                Filter: ''
            },
            {
                Header: 'Username',
                accessor: 'userName',
                Cell: ({ row }) => (<span>{row.original.userName ? row.original.userName : 'N/A'}</span>),
                Filter: ''
            },
            {
                Header: 'Email',
                accessor: 'email',
                Cell: ({ row }) => (<span>{row.original.email ? row.original.email : 'N/A'}</span>),
                Filter: ''
            },
            {
                Header: 'Role',
                accessor: 'groups',
                Cell: ({ row }) => (<span>{row.original.groups ? this.getRoleNames(row.original.groups) : 'N/A'}</span>),
                Filter: '',
                disableSortBy: true
            },
            {
                Header: 'Status',
                userStatus: true
            },
            {
                Header: ' ',
                userAction: true
            }

        ];
        return (<>
            {loading ? <div className="loading-overlay"><span>{actions.load}</span></div> : null}
            <Header />
            <div className="bgGray">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-1">
                            <SideMenu />
                        </div>
                        <div className="col-md-11">
                            <div className="surgeon-list data-list-tabs table-wrap px-3" data-testid="userList">
                                <div className="row">
                                    <div className="col-md-12">
                                        <h1 className="file-list-heading">User List</h1>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-6">
                                        <UserSearchComponent handleSearchSubmit={handleSearchSubmit} handleReset={handleReset} />
                                    </div>
                                    <div className="col-3">
                                        <div className="d-flex align-items-center pt-3">
                                            <label className="me-2">Active Users Only</label>
                                            <label className="switch active-users-filter">
                                                <input data-testid='active-users-toggle' onChange={(e) => filterActiveUsers(e.target.checked)} type="checkbox" defaultChecked={true} />
                                                <div className="slider round">
                                                    <span className="on">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-power" viewBox="0 0 16 16">
                                                            <path d="M7.5 1v7h1V1h-1z" />
                                                            <path d="M3 8.812a4.999 4.999 0 0 1 2.578-4.375l-.485-.874A6 6 0 1 0 11 3.616l-.501.865A5 5 0 1 1 3 8.812z" />
                                                        </svg>
                                                    </span>
                                                    <span className="off">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#ccc" className="bi bi-power" viewBox="0 0 16 16">
                                                            <path d="M7.5 1v7h1V1h-1z" />
                                                            <path d="M3 8.812a4.999 4.999 0 0 1 2.578-4.375l-.485-.874A6 6 0 1 0 11 3.616l-.501.865A5 5 0 1 1 3 8.812z" />
                                                        </svg>
                                                    </span>
                                                </div>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-3 text-end">
                                        <AddUserModalComponent fromDashboard={fromDashboard} userUpdated={userUpdated} />
                                    </div>
                                </div>
                                <div className="user-list-container">
                                    <DataTable
                                        listType="user-list"
                                        showPagination={true}
                                        columns={columns}
                                        newUserName={newUserName ? newUserName : ''}
                                        searchString={searchString && searchSubmit ? searchString : ''}
                                        activeUsersOnly={activeUsersOnly}
                                        refreshDataList={searchSubmit || refreshUserList}
                                        userStatusUpdated={userStatusUpdated}
                                        toggleLoader={toggleLoader}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>);
    }
}
const mapStateToProps = (state) => ({ state })
const mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(UserListComponent);
